import { render, staticRenderFns } from "./FamilyClient.vue?vue&type=template&id=6027cea6&scoped=true"
import script from "./FamilyClient.vue?vue&type=script&lang=js"
export * from "./FamilyClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6027cea6",
  null
  
)

export default component.exports